import { Box, CircularProgress, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import axios from "axios";
import Heading from "../../AdminComponents/Common/Heading";
import { currencyOptions } from "../../Services/dymmyData";
import Dropdown from "../../AdminComponents/Common/Dropdown";
import CustomButton from "../../Components/Common/CustomButton";
import TextArea from "../../AdminComponents/Common/TextArea";
import { BASE_URL } from "../../Assets/Constants";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import ReactQuill from "react-quill";
import { theme } from "../../Assets/Theme/theme";

function Settings() {
  const navigate = useNavigate();
  const [inputValues, setInputValues] = useState({
    currency: "",
    email: "",
  });
  const [loading, setLoading] = useState(false)
  const [errors, setErrors] = useState([]);
  const loginData = JSON.parse(localStorage.getItem("adminData"));
  const token = loginData?.token;

  const sanitizeEmailTemplate = (content) => {
    const sanitized = content.replace(/<p><br><\/p>/g, "").trim();
    return sanitized.length > 0 ? sanitized : "";
  };

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/admin/setting`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.data.success) {
          setInputValues({
            currency: response.data.data.currency || "",
            email: response.data.data.emailTemplate || "",
          });
        }
      } catch (error) {
        console.error("Error fetching settings:", error);
      }
    };

    fetchSettings();
  }, []);

  const handleInputChange = (field, value) => {
    setInputValues((prev) => ({
      ...prev,
      [field]: value?.target?.value,
    }));
  };

  const updateSettings = async () => {
    setLoading(true)
    const sanitizedEmail = sanitizeEmailTemplate(inputValues.email);
    try {
      const response = await axios.put(
        `${BASE_URL}/admin/setting/update`,
        {
          currency: inputValues.currency,
          emailTemplate: sanitizedEmail,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      toast.success("Settings updated successfully!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        style: { backgroundColor: 'orange', color: 'white' },
      });
    } catch (error) {
      setErrors(error?.response?.data?.error || []);
      console.error("Error updating settings:", error);
    } finally {
      setLoading(false)
    }
  };

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === "Enter") {
        updateSettings()
      }
    };

    window.addEventListener("keypress", handleKeyPress);

    return () => {
      window.removeEventListener("keypress", handleKeyPress);
    };
  }, [inputValues]);

  const getErrorMessage = (field) => {
    const fieldError = Array.isArray(errors)
      ? errors.find((err) => err?.path === field)
      : null;
    return fieldError?.msg || null;
  };

  const clearErrorMessage = (field) => {
    setErrors((prevErrors) => prevErrors.filter((err) => err?.path !== field));
  };

  return (
    <Box>
      <Heading label={"Settings"} />
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          flexDirection: "column",
          height: "80vh",
          gap: 2,
        }}
      >
        <Box mt={2} width={"100%"}>
          <Box width={{ xs: "100%", md: 250 }} mb={5}>
            <Dropdown
              options={currencyOptions}
              placeholder="Select Currency"
              label={"Currency Options"}
              value={inputValues.currency}
              onChange={(value) => {
                setErrors((prevErrors) =>
                  prevErrors.filter((err) => err.path !== "currency")
                );
                handleInputChange("currency", value)
              }}
              images
            />
            {getErrorMessage("currency") && (
              <Box color="red" mb={1} mt={0}>
                {getErrorMessage("currency")}
              </Box>
            )}
          </Box>
          {/* <TextArea
            label="Email Templating"
            value={inputValues.email}
            onChange={(e) =>
              setInputValues({ ...inputValues, email: e.target.value })
            }
            rows={14}
            placeholder="Enter your email template..."
          /> */}
          <Typography
            variant="body1"
            sx={{
              fontWeight: 700,
              mb: 2,
              color: theme.colors.text || "#333",
              fontSize: "20px"
            }}
          >
            Email Templating
          </Typography>
          <ReactQuill theme="snow" value={inputValues?.email} style={{
            height: "200px",
          }} onChange={(content) => {
            setInputValues({ ...inputValues, email: content })
            setErrors((prevErrors) =>
              prevErrors.filter((err) => err.path !== "emailTemplate")
            );
          }

          } />
        </Box>
        {getErrorMessage("emailTemplate") && (
          <Box color="red" mb={2} mt={5}>
            {getErrorMessage("emailTemplate")}
          </Box>
        )}
        <Box width={{ xs: "100%", md: "50%" }} mx={"auto"}>
          <CustomButton style={{ fontSize: "18px" }}
            disabled={loading}
            onClick={updateSettings}>
            {loading ? <CircularProgress size={30} sx={{ color: "white" }} /> : 'Save'}
          </CustomButton>
        </Box>
      </Box>
    </Box>
  );
}

export default Settings;
